const Panel2Icon = ({ strokeColor = '#808080' }) => {
  return (
    <svg 
      viewBox="0 0 795.1 795.1"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full h-full"
    >
      <defs>
        <style>{`
          .cls-1 {
            fill: #fcfcfc;
          }
          .cls-2 {
            fill: #4d4d4d;
          }
          .cls-3 {
            stroke: ${strokeColor};
            stroke-width: 50px;
          }
          .cls-3, .cls-4 {
            fill: none;
            stroke-miterlimit: 10;
          }
          .cls-5 {
            fill: #fefefe;
          }
          .cls-4 {
            stroke: #fff;
            stroke-width: 20px;
          }
          .cls-6 {
            fill: #fdfdfd;
          }
        `}</style>
      </defs>
      <g id="Circles">
        <circle id="Grey_Bkg" data-name="Grey Bkg" className="cls-2" cx="397.55" cy="397.55" r="388.66"/>
        <circle id="Grey" className="cls-3" cx="397.55" cy="397.55" r="372.55"/>
        <circle id="White_Inner" data-name="White Inner" className="cls-4" cx="397.55" cy="397.55" r="343.4"/>
      </g>
      <g id="Shapes">
        <g id="Layer_1-2" data-name="Layer 1-2">
          <path className="cls-6" d="M545,573.44c-.09,13.81,1.55,26.96-7.13,38.47-8.81,11.69-20.42,18.31-34.73,18.38-70.07.31-140.15.33-210.22.03-24.18-.1-42.88-19.75-42.88-43.83-.02-125.63-.02-251.26,0-376.89,0-26.15,18.93-45.02,45.09-45.03,68.68-.02,137.35-.03,206.03,0,24.53.01,43.82,19.25,43.83,43.7.02,121.44.01,242.88.01,365.16M519.7,398.32c0-62.25,0-124.5-.02-186.76,0-13.59-7.63-21.83-20.56-21.85-67.56-.08-135.11-.08-202.67,0-13.12.02-20.43,7.7-20.44,20.84,0,21.22-.02,42.43-.02,63.65,0,103.01,0,206.02.05,309.03,0,14.94,6.91,21.89,21,21.88,66.16-.04,132.32-.04,198.48-.05,17.46,0,24.17-6.68,24.17-24.16,0-60.3,0-120.6,0-182.57h0Z"/>
          <path className="cls-1" d="M407.78,226.18c28.8,3.99,52.1,29.57,53.4,58.02,1.35,29.66-20.01,58.13-48.45,64.56-33.48,7.58-67.64-12.75-75.5-44.94-8.35-34.19,10.36-66.79,44.47-75.99,8.04-2.17,16.9-1.3,26.09-1.65M434.48,297.48c4.46-15.12-1.54-31.43-15.02-40.87-12.87-9-30.26-9.03-42.73-.06-13.59,9.77-19.36,25.67-14.82,40.84,4.79,16,18.67,27.34,34.31,28.02,17.12.75,30.8-8.77,38.26-27.93h0Z"/>
          <path className="cls-5" d="M441.07,464.82c-34.56.02-68.28.05-102.01.05-10.67,0-16.28-4.41-16.14-12.51.13-7.55,6.8-12.95,16.28-12.96,39.3-.03,78.6-.03,117.9,0,9.53,0,15.48,4.72,15.78,12.32.3,7.61-6.14,12.95-15.92,13.11-5.02.08-10.03,0-15.89,0h0Z"/>
          <path className="cls-5" d="M369.03,389.11c29.85,0,58.86-.01,87.87,0,10.14,0,16.02,4.66,16.03,12.61,0,7.91-5.91,12.62-16.09,12.63-39.33.03-78.66.04-118,.02-10.46,0-15.59-4.42-15.42-13.06.15-7.91,5.53-12.17,15.48-12.2,9.76-.02,19.53,0,30.13,0h0Z"/>
          <path className="cls-6" d="M416.78,512.98c-4.37.97-8.14,2.10-11.91,2.13-21.71.18-43.42.11-65.13.09-10.98,0-17.3-4.61-17.23-12.45.06-7.56,7.17-13.06,17.07-13.08,22.55-.04,45.09.08,67.64-.08,6.09-.04,10.85,1.65,13.63,7.34,3,6.14,1.16,11.23-4.06,16.04h0Z"/>
        </g>
      </g>
    </svg>
  );
};

export default Panel2Icon;